import mediaLibrary from "./mediaLibrary";
import folderCollections from "./folderCollections";
import filesCollection from "./fileCollections";

export default {
	backend: {
		name: "gitlab",
		repo: "montessoribaby/montessoribaby-cms"
	},

	media_folder: "static/img",
	public_folder: "/img",
	logo_url: "https://res.cloudinary.com/gozali/image/upload/w_192/v1561554428/logos/logo-black.png",
	site_url: "https://montessori-baby.com",

	media_library: mediaLibrary,

	collections: [
		//FOLDER COLLECTIONS
		...folderCollections,
		//FILES COLLECTION
		filesCollection,
	],
};

// backend:
//   name: git-gateway
//   branch: master

// media_library:
//   name: cloudinary
//   config:
//     cloud_name: montessoribaby
//     api_key: 128391412231336
//     default_transformations:
//       -   - fetch_format: auto
//             quality: auto

// media_folder: static/img
// public_folder: /img
// logo_url: https://res.cloudinary.com/gozali/image/upload/w_192/v1561554428/logos/logo-black.png
// site_url: https://montessori-baby.com

// collections:
//   - name: "blog"
//     label: "Blog"
//     folder: "content/blog"
//     filter: {field: "templateKey", value: "blog-post"}
//     create: true
//     slug: "{{year}}-{{month}}-{{day}}-{{slug}}"
//     summary: "[{{year}}/{{month}}/{{day}}] {{title}}"
//     preview_path: "blog/{{year}}-{{month}}-{{day}}-{{slug}}"
//     preview_path_date_field: "date"
//     delete: false
//     fields:
//       - {label: "Template Key", name: "templateKey", widget: "hidden", default: "blog-post"}
//       - {label: "Title", name: "title", widget: "string"}
//       - {label: "Author", name: "author", widget: "string", default: "מונטסורי בייבי"}
//       - {label: "Publish Date", name: "date", widget: "datetime"}
//       - {label: "Description", name: "description", widget: "text"}
//       - {label: "Featured Post", name: "featuredpost", widget: "boolean", default: false}
//       - {label: "Image", name: "image", widget: image}
//       - {label: "Body", name: "body", widget: "rtlmarkdown"}
//       - {label: "Tags", name: "tags", widget: "list"}
//       - {label: "Image vertical position", name: "imageYPosition", widget: "select", default: "center", options: [
//         {label: "Top", value: "top"},
//         {label: "Bottom", value: "bottom"},
//         {label: "Center", value: "center"},
//         {label: "Y: 0", value: "0%" },
//         {label: "Y: 10%", value: "10%" },
//         {label: "Y: 20%", value: "20%" },
//         {label: "Y: 30%", value: "30%" },
//         {label: "Y: 35%", value: "35%" },
//         {label: "Y: 40%", value: "40%" },
//         {label: "Y: 50%", value: "50%" },
//         {label: "Y: 55%", value: "55%" },
//         {label: "Y: 60%", value: "60%" },
//         {label: "Y: 70%", value: "70%" },
//         {label: "Y: 75%", value: "75%" },
//         {label: "Y: 80%", value: "80%" },
//         {label: "Y: 90%", value: "90%" },
//       ]}
//       - {label: "PostId", name: "postId", widget: "postId"}
//       - {label: "Publish to Facebook", name: "fbPublish", widget: "boolean", default: true}
//       - {label: "Publish to Twitter", name: "twitterPublish", widget: "boolean", default: true}
//       - {label: "Social Publish Text", name: "socialText", widget: "text", required: false}

//   - name: "product"
//     label: "Products"
//     folder: "content/products"
//     filter: {field: "templateKey", value: "product-page"}
//     create: true
//     slug: "{{year}}-{{month}}-{{day}}-{{slug}}"
//     summary: "[{{year}}/{{month}}/{{day}}] {{title}}"
//     delete: false
//     fields:
//       - {label: "Template Key", name: "templateKey", widget: "hidden", default: "product-page"}
//       - {label: "Title", name: "title", widget: "string"}
//       - {label: "Publish Date", name: "date", widget: "datetime"}
//       - {label: "Description", name: "description", widget: "text"}
//       - {label: "Featured Post", name: "featuredpost", widget: "boolean", required: false}
//       - {label: "Image", name: "image", widget: image}
//       - {label: "Buy Link", name: "buyLink", widget: "hidden", required: false}
//       - {label: "Amazon Id", name: "amazonId", widget: "string", required: false}
//       - {label: "Body", name: "body", widget: "rtlmarkdown"}
//       - {label: "Tags", name: "tags", widget: "list"}
//       - {label: "Image vertical position", name: "imageYPosition", widget: "select", default: "center", options: [
//         {label: "Top", value: "top"},
//         {label: "Bottom", value: "bottom"},
//         {label: "Center", value: "center"},
//         {label: "Y: 0", value: "0%" },
//         {label: "Y: 10%", value: "10%" },
//         {label: "Y: 20%", value: "20%" },
//         {label: "Y: 30%", value: "30%" },
//         {label: "Y: 35%", value: "35%" },
//         {label: "Y: 40%", value: "40%" },
//         {label: "Y: 50%", value: "50%" },
//         {label: "Y: 55%", value: "55%" },
//         {label: "Y: 60%", value: "60%" },
//         {label: "Y: 70%", value: "70%" },
//         {label: "Y: 75%", value: "75%" },
//         {label: "Y: 80%", value: "80%" },
//         {label: "Y: 90%", value: "90%" },
//       ]}
//       - {label: "PostId", name: "postId", widget: "postId"}
//       - {label: "Publish to Facebook", name: "fbPublish", widget: "boolean", default: true}
//       - {label: "Publish to Twitter", name: "twitterPublish", widget: "boolean", default: true}
//       - {label: "Social Publish Text", name: "socialText", widget: "text", required: false}

//   - name: "event"
//     label: "Events"
//     folder: "content/events"
//     filter: {field: "templateKey", value: "event-page"}
//     create: true
//     slug: "{{year}}-{{month}}-{{day}}-{{slug}}"
//     summary: "[{{year}}/{{month}}/{{day}}] {{title}}"
//     delete: false
//     fields:
//       - {label: "Template Key", name: "templateKey", widget: "hidden", default: "event-page"}
//       - {label: "Title", name: "title", widget: "string"}
//       - {label: "Event Date", name: "date", widget: "datetime"}
//       - {label: "Link to Event (FB)", name: "link", widget: "string", required: false, default: ""}
//       - {label: "Featured Post", name: "featuredpost", widget: "boolean", required: false}
//       - {label: "Body", name: "body", widget: "rtlmarkdown"}
//       - {label: "Image", name: "image", widget: image}
//       - {label: "Location", name: "location", widget: "map", required: false}
//       - {label: "Tags", name: "tags", widget: "list"}
//       - {label: "Image vertical position", name: "imageYPosition", widget: "select", default: "center", options: [
//         {label: "Top", value: "top"},
//         {label: "Bottom", value: "bottom"},
//         {label: "Center", value: "center"},
//         {label: "Y: 0", value: "0%" },
//         {label: "Y: 10%", value: "10%" },
//         {label: "Y: 20%", value: "20%" },
//         {label: "Y: 30%", value: "30%" },
//         {label: "Y: 35%", value: "35%" },
//         {label: "Y: 40%", value: "40%" },
//         {label: "Y: 50%", value: "50%" },
//         {label: "Y: 55%", value: "55%" },
//         {label: "Y: 60%", value: "60%" },
//         {label: "Y: 70%", value: "70%" },
//         {label: "Y: 75%", value: "75%" },
//         {label: "Y: 80%", value: "80%" },
//         {label: "Y: 90%", value: "90%" },
//       ]}
//       - {label: "PostId", name: "postId", widget: "postId"}
//       - {label: "Publish to Facebook", name: "fbPublish", widget: "boolean", default: false}
//       - {label: "Publish to Twitter", name: "twitterPublish", widget: "boolean", default: true}
//       - {label: "Social Publish Text", name: "socialText", widget: "text", required: false}

//   - name: "glossary"
//     label: "Glossary Item"
//     folder: "content/glossary"
//     filter: {field: "templateKey", value: "glossary-item-page"}
//     create: true
//     slug: "{{slug}}"
//     summary: "{{title}}"
//     delete: false
//     fields:
//     - {label: "Template Key", name: "templateKey", widget: "hidden", default: "glossary-item-page"}
//     - {label: "Title", name: "title", widget: "string"}
//     - {label: "Body", name: "body", widget: "rtlmarkdown"}
//     - {label: "Image", name: "image", widget: image, default: "https://res.cloudinary.com/montessoribaby/image/upload/v1566337022/pages/glossary.jpg"}
//     - {label: "Image vertical position", name: "imageYPosition", widget: "select", default: "center", options: [
//         {label: "Top", value: "top"},
//         {label: "Bottom", value: "bottom"},
//         {label: "Center", value: "center"},
//         {label: "Y: 0", value: "0%" },
//         {label: "Y: 10%", value: "10%" },
//         {label: "Y: 20%", value: "20%" },
//         {label: "Y: 30%", value: "30%" },
//         {label: "Y: 35%", value: "35%" },
//         {label: "Y: 40%", value: "40%" },
//         {label: "Y: 50%", value: "50%" },
//         {label: "Y: 55%", value: "55%" },
//         {label: "Y: 60%", value: "60%" },
//         {label: "Y: 70%", value: "70%" },
//         {label: "Y: 75%", value: "75%" },
//         {label: "Y: 80%", value: "80%" },
//         {label: "Y: 90%", value: "90%" },
//     ]}
//     - {label: "PostId", name: "postId", widget: "postId"}

//   - name: "testimonial"
//     label: "Testimonial"
//     folder: "content/testimonials"
//     #filter: {field: "templateKey", value: "event-page"}
//     create: true
//     slug: "{{slug}}"
//     summary: "{{name}}"
//     identifier_field: "name"
//     delete: false
//     fields:
//     - {label: "Template Key", name: "templateKey", widget: "hidden", default: "index-page"}
//     - {label: "Name", name: "name", widget: "string"}
//     - {label: "Role", name: "role", widget: "string"}
//     - {label: "Body", name: "body", widget: "rtlmarkdown"}
//     - {label: "PostId", name: "postId", widget: "postId"}
//     - {label: "Type", name: "type", widget: "hidden", default: "testimonial"}
//     - label: "Image"
//       required: false
//       name: "image"
//       widget: image
//       media_library:
//         config:
//           default_transformations:
//             -   - fetch_format: png
//                   format: png
//                   quality: auto
//                   crop: thumb
//                   radius: max
//                   effect: sepia
//                   width: 140
//                   height: 100
//                   dpr: 2

//   - name: "pages"
//     label: "Pages"
//     files:
//       - file: "content/index.md"
//         label: "Home Page"
//         name: "index"
//         fields:
//           - {label: "Template Key", name: "templateKey", widget: "hidden", default: "index-page"}
//           - {label: Title, name: title, widget: string}
//           - {label: Image, name: image, widget: image}
//           - {label: "Heading", name: "heading", widget: "string"}
//           - {label: "Subheading", name: subheading, widget: string}
//           - {label: "Main Quote", name: mainQuote, widget: object, fields: [{label: Text, name: text, widget: string}, {label: Name, name: name, widget: string}]}

//       - file: "content/blog/index.md"
//         label: "Blog Index"
//         name: "blog-index"
//         fields:
//           - {label: "Template Key", name: "templateKey", widget: "hidden", default: "blog-index-page"}
//           - {label: Title, name: title, widget: string}
//           - {label: Image, name: image, widget: image}
//           - {label: Heading, name: heading, widget: string, required: false}
//           - {label: "Body", name: "body", widget: "rtlmarkdown", requierd: false}
//           - {label: "Image vertical position", name: "imageYPosition", widget: "select", default: "center", options: [
//             {label: "Top", value: "top"},
//             {label: "Bottom", value: "bottom"},
//             {label: "Center", value: "center"},
//             {label: "Y: 0", value: "0%" },
//             {label: "Y: 10%", value: "10%" },
//             {label: "Y: 20%", value: "20%" },
//             {label: "Y: 30%", value: "30%" },
//             {label: "Y: 35%", value: "35%" },
//             {label: "Y: 40%", value: "40%" },
//             {label: "Y: 50%", value: "50%" },
//             {label: "Y: 55%", value: "55%" },
//             {label: "Y: 60%", value: "60%" },
//             {label: "Y: 70%", value: "70%" },
//             {label: "Y: 75%", value: "75%" },
//             {label: "Y: 80%", value: "80%" },
//             {label: "Y: 90%", value: "90%" },
//             ]}

//       - file: "content/products/index.md"
//         label: "Product Index"
//         name: "products-index"
//         fields:
//           - {label: "Template Key", name: "templateKey", widget: "hidden", default: "products-index-page"}
//           - {label: Title, name: title, widget: string}
//           - {label: Image, name: image, widget: image}
//           - {label: Heading, name: heading, widget: string, required: false}
//           - {label: "Body", name: "body", widget: "rtlmarkdown", requierd: false}
//           - {label: "Image vertical position", name: "imageYPosition", widget: "select", default: "center", options: [
//             {label: "Top", value: "top"},
//             {label: "Bottom", value: "bottom"},
//             {label: "Center", value: "center"},
//             {label: "Y: 0", value: "0%" },
//             {label: "Y: 10%", value: "10%" },
//             {label: "Y: 20%", value: "20%" },
//             {label: "Y: 30%", value: "30%" },
//             {label: "Y: 35%", value: "35%" },
//             {label: "Y: 40%", value: "40%" },
//             {label: "Y: 50%", value: "50%" },
//             {label: "Y: 55%", value: "55%" },
//             {label: "Y: 60%", value: "60%" },
//             {label: "Y: 70%", value: "70%" },
//             {label: "Y: 75%", value: "75%" },
//             {label: "Y: 80%", value: "80%" },
//             {label: "Y: 90%", value: "90%" },
//             ]}


//       - file: "content/about/index.md"
//         label: "About"
//         name: "about"
//         fields:
//           - {label: "Template Key", name: "templateKey", widget: "hidden", default: "about-page"}
//           - {label: "Title", name: "title", widget: "string"}
//           - {label: Image, name: image, widget: image}
//           - {label: "Sections", name: "sections", widget: "list"}
//           - {label: "Body", name: "body", widget: "rtlmarkdown"}

//       - file: "content/contact/index.md"
//         label: "Contact"
//         name: "contact"
//         fields:
//             - {label: "Template Key", name: "templateKey", widget: "hidden", default: "about-page"}
//             - {label: "Title", name: "title", widget: "string"}
//             - {label: Image, name: image, widget: image}
//             - {label: "Body", name: "body", widget: "rtlmarkdown"}

//       - file: "content/services/index.md"
//         label: "Services"
//         name: "services-index"
//         fields:
//             - {label: "Template Key", name: "templateKey", widget: "hidden", default: "services-index-page"}
//             - {label: "Title", name: "title", widget: "string"}
//             - {label: Image, name: image, widget: image}
//             - {label: "Sections", name: "sections", widget: "list"}
//             - {label: "Body", name: "body", widget: "rtlmarkdown"}




